import { useTranslation } from 'react-i18next';
import './PartnersTab.scss';
import '../MastersAndPartnersTabs.scss';
import Paragraph from 'components/TextComps/Paragraph';
import { MastersAndPartnersCard, MastersAndPartnersLoadingCard } from '../MastersAndPartnersCard/MastersAndPartnersCard';
import { useGetPartners } from 'queryHooks/partners';

export const PartnersTab = () => {
  const { t } = useTranslation();
  const { data: partnersList, isPending } = useGetPartners();

  return (
    <div className='masters-and-partners-tab'>
      <div className='masters-and-partners-header'>
        <h2>{t('PartnerGalleryTitle', { ns: 'partnersGallery' })}</h2>
        <Paragraph>
          <>{t('LearnMoreAboutPartners', { ns: 'partnersGallery' })}</>
        </Paragraph>
      </div>
      <div className='masters-and-partners-gallery'>
        {!isPending
          ? partnersList?.map((partner, i) => (
              <>
                <MastersAndPartnersCard
                  key={`partner-${i}`}
                  id={`partner-${i}`}
                  name={partner.fullName}
                  imgUrl={partner.imageUrl}
                  description={partner.description}
                />
              </>
            ))
          : Array.from(Array(10)).map((_, i) => <MastersAndPartnersLoadingCard key={`loading-partner-${i}`} id={`loading-partner-${i}`} />)}
      </div>
    </div>
  );
};
